<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-01">When the times change, all men change with them. So many of both the friends and critics of the police talk as if police constables were not men.</p>
<p class="fm-02"><span>—<span class="smallcaps">WITNESS, ROYAL COMMISSION ON POLICE POWERS</span></span></p>
<p class="fm-03">To the ordinary soldier, the battle is his own small part of the front.</p>
<p class="fm-02"><span>—<span class="smallcaps">GENERAL GRANT</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter01.vue?175a744c